export const C5Helper = {
  /**
   * Tests if the given object has a valid id and is therefore an existing
   * entity. When creating new entries we set the id to a fixed value (mostly it's
   * undefined, but sometimes it has to be zero because the C5 expects it that way).
   */
  isNew(item: any): boolean {
    return item == null || item.id === 0 || item.id == null || item.id === '';
  },
};
